export default () => ({
  questionWrapper: {
    '&:not(first-child)': {
      marginTop: 20,
    },
  },
  nonProviderQuestionWrapper: {
    width: '100%',
    maxWidth: 1360,
    marginLeft: 'auto',
    marginRight: 'auto',
    /* for a long question on mob dev to scroll to the bottom option */
    paddingBottom: 100,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  providerQuestionWrapper: {
    width: '100%',
    maxWidth: 600,
    marginLeft: 'auto',
    marginRight: 'auto',
    /* for a long question on mob dev to scroll to the bottom option */
    paddingBottom: 64,
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    flex: 1,
  },
  progressMenu: {
    position: 'sticky',
    top: ({ provider }) => (provider ? 40 : 56), // header height
    zIndex: 10,
  },
});
